import logo from './LogoFull.svg';

export const LogoFull = () => <img src={logo} alt="Quasar" height={30} />;
